<template>
  <v-container xs12 fluid class="pt-0">
    <v-card class="pa-2 card-r pb-4 shadow-1">
      <v-toolbar class="primary darken-2 card-r pl-3 text-white">
        <div class="text-xs-left f-20">Teachers</div>
        <!--<div class="text-xs-left f-20">Total Earnings </div>-->
      </v-toolbar>
      <!--<h1 class="title">Students</h1>-->
      <v-layout mt-2>
            <v-flex xs12>
              <v-card class="grey lighten-4 mt-3 pa-2 shadow-1">
                <v-flex xs12 lg6 class="ma-auto pb-3 pt-2 hide-pro pro">
                  <v-text-field solo append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
                </v-flex>
                <v-data-table :search="search" :headers="headers" :items="TeacherList" class="  card-r no-shadow laptop-data-table">
                  <template slot="items" slot-scope="props">
                    <td class="word-break">{{ props.item.name }}</td>
                    <td>+45{{ props.item.phone }}</td>
                    <td>{{ props.item.number_of_students}}</td>
                    <td class="word-break">{{ props.item.email }}</td>
                    <td>{{ props.item.gender }}</td>
                    <td>
                      <div v-if="props.item.status" class="pro pt-2 hide-pro">
                        <v-select solo
                                  v-model="props.item.status"
                                  :items="teacherStatus"
                                  item-text="props.item.status"
                                  item-value="props.item.status"
                                  @change=changestatus(props.item.id,props.item.status)
                                  persistent-hint
                                  return-object
                                  single-line
                        ></v-select>
                      </div>
                    </td>
                    <td class="layout px-0">
                      <v-btn class="shadow-1" icon v-bind:to="'/teachers/Lists/edit/'+props.item.id">
                        <v-icon class="text-green f-12" to="/EditTeacherList">fa-edit</v-icon>
                      </v-btn>
                      <v-btn class="shadow-1" icon v-bind:to="'/teacherprofile/'+props.item.id">
                        <v-icon class="text-green f-12" to="/teacherprofile">fa-sign-in-alt</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
      </v-layout>
       <v-layout mt-2 row>
            <v-flex xs12>
                <v-data-table :search="search" :items="TeacherList" class="  card-r no-shadow mobile-data-table">
                    <template slot="items" slot-scope="props">
                       <v-card class="mb-3 grey lighten-3 pa-3 pt-4 no-shadow card-r">
                        <v-flex><span class="font-weight-bold mr-1">Name: </span>{{ props.item.name }}</v-flex>
                        <v-flex><span class="font-weight-bold mr-1">Phone: </span>+45{{ props.item.phone }}</v-flex>
                        <v-flex><span class="font-weight-bold mr-1">No.of Students:</span>{{ props.item.number_of_students}}</v-flex>
                        <v-flex><span class="font-weight-bold mr-1">Email: </span>{{ props.item.email }}</v-flex>
                        <v-flex><span class="font-weight-bold mr-1">Gender: </span>{{ props.item.gender }}</v-flex>

                          <v-flex xs8 v-if="props.item.status">
                            <v-select
                            class="mt-0 pt-0"
                              v-model="props.item.status"
                              :items="teacherStatus"
                              item-text="props.item.status"
                              item-value="props.item.status"
                              @change=changestatus(props.item.id,props.item.status)
                              persistent-hint
                              return-object
                              single-line
                            ></v-select>
                          </v-flex>

                          <v-flex class="text-xs-right">
                            <v-btn class="ma-0" icon v-bind:to="'/teachers/edit/'+props.item.id">
                              <v-icon class="grey--text" to="/">fa-edit</v-icon>
                            </v-btn>
                              <v-btn class="ma-0" icon v-bind:to="'/teacherprofile/'+props.item.id">
                                <v-icon class="grey--text" to="/teacherprofile">fa-sign-in-alt</v-icon>
                              </v-btn>

                          </v-flex>
                        </v-card>
                    </template>
                </v-data-table>
            </v-flex>
      </v-layout>
      <!--<add-new-teacher/>-->
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */
import AddNewTeacher from "./AddNewTeacher.vue";
import { dispatch } from "vuex";

export default {
  name: "Teachers",
  data() {
    return {
      search: '',
      headers: [
        { text: "NAME", value: "name" },
        { text: "CONTACT", value: "phone" },
        { text: "NO OF STUDENT", value: "noOfStudent" },
        { text: "EMAIL", value: "email" },
        { text: "GENDER", value: "gender" },
        { text: "STATUS", value: "status" },
        { text: "ACTIONS", value: "" }
      ],
      TeacherList:[],
      teacherStatus:["active","inactive","blocked"]
    };
  },
  created(){
    Store.commit("setLoading", { loading: true });
    Store.dispatch("Teachers/getAllTeachers")
    .then(res => {
      this.TeacherList = res;
      Store.commit("setLoading", { loading: false });
    })
    .catch(() => {
      Store.commit("setLoading", { loading: false });
    });
  },
  methods:{
    changestatus(teacherid,status) {
      //
      var Data={
        "teacherid":teacherid,
        "status":status
      }
      this.$store.dispatch("Teachers/changeTeacherStatus", Data)
    }
  },
  components: {
    AddNewTeacher
  }
};
</script>
<style>
  /* .v-select__slot{
    width:65px !important;
  } */
  .v-select__slot div{
    font-size: 13px !important;
    border:none
  }
  .v-text-field.v-input--is-focused .v-input__slot:after{
    display:none !important;
  }
  .v-text-field>.v-input__control>.v-input__slot:before{
    display: none !important;
  }

  @media (min-width: 1281px) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    }

    /*
      ##Device = Laptops, Desktops
      ##Screen = B/w 1025px to 1280px
    */

    @media (min-width: 1025px) and (max-width: 1280px) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    }

    /*
      ##Device = Tablets, Ipads (portrait)
      ##Screen = B/w 768px to 1024px
    */

    /* @media (min-width: 768px) and (max-width: 1024px) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    } */

    /*
      ##Device = Tablets, Ipads (landscape)
      ##Screen = B/w 768px to 1024px
    */

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    }

    /*
      ##Device = Low Resolution Tablets, Mobiles (Landscape)
      ##Screen = B/w 481px to 767px
    */

    @media (min-width: 481px) and (max-width: 767px) {
          .mobile-data-table{
              display: block
          }
          .laptop-data-table{
              display: none
          }
    }

    /*
      ##Device = Most of the Smartphones Mobiles (Portrait)
      ##Screen = B/w 320px to 479px
    */

    @media (min-width: 320px) and (max-width: 480px) {
          .mobile-data-table{
              display: block
          }
          .laptop-data-table{
              display: none
          }
    }

</style>



// WEBPACK FOOTER //
// src/components/pages/teacher/Teachers.vue